import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { initRawSchema } from '@principle-theorem/editor';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { PartnerStatusComponent } from '@principle-theorem/ng-principle';
import {
  BreadcrumbsComponent,
  DialogPresets,
  InputSearchFilter,
  PipesModule,
  SearchFieldComponent,
  TypedFormControl,
} from '@principle-theorem/ng-shared';
import { Partner } from '@principle-theorem/principle-core';
import { type IPartner } from '@principle-theorem/principle-core/interfaces';
import { Firestore, type WithRef } from '@principle-theorem/shared';
import { startWith } from 'rxjs/operators';
import {
  PartnerAddDialogComponent,
  PartnerFormData,
} from '../partner-add-dialog/partner-add-dialog.component';

@Component({
  selector: 'pr-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    BreadcrumbsComponent,
    SearchFieldComponent,
    ReactiveFormsModule,
    PartnerStatusComponent,
    NgMaterialModule,
    RouterModule,
    PipesModule,
  ],
})
export class PartnersComponent {
  search: TypedFormControl<string> = new TypedFormControl<string>('');
  searchFilter: InputSearchFilter<WithRef<IPartner>>;

  constructor(
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {
    this.searchFilter = new InputSearchFilter<WithRef<IPartner>>(
      Partner.all$(),
      this.search.valueChanges.pipe(startWith('')),
      ['name']
    );
  }

  async addPartner(): Promise<void> {
    const partnerData = await this._dialog
      .open<PartnerAddDialogComponent, undefined, PartnerFormData>(
        PartnerAddDialogComponent,
        DialogPresets.small()
      )
      .afterClosed()
      .toPromise();

    if (!partnerData) {
      return;
    }

    await Firestore.addDoc(
      Partner.col(),
      Partner.init({ ...partnerData, description: initRawSchema() })
    );
    this._snackBar.open('Partner Added');
  }

  getRegions(partner: WithRef<IPartner>): string {
    return partner.regions.join(', ');
  }
}
